import { writable } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';
import { updateLookup } from '../api/data-handler.js';
import { getAllLookups } from '../api/data-handler.js';
import { logError } from '../logging/log-handler.js';

export interface LookupItem {
    id: string;
    name: string;
}

interface LookupDrawerState {
    instanceId: string;
    open: boolean;
    section: 'therapeutic' | 'source' | 'topics' | null;
    items: LookupItem[];
    lookupId: string;
    lookupState: string;
}

export const lookupDrawerStore = writable<LookupDrawerState>({
    instanceId: uuidv4(),
    open: false,
    section: null,
    items: [],
    lookupId: '',
    lookupState: ''
});

export function editLookup(section: 'therapeutic' | 'source' | 'topics', items: LookupItem[], lookupId: string, lookupState: string) {
    lookupDrawerStore.set({
        instanceId: uuidv4(),
        open: true,
        section,
        items: [...items],
        lookupId,
        lookupState
    });
}

export function closeLookupDrawer() {
    lookupDrawerStore.update(store => ({ ...store, open: false }));
}

export async function saveLookup(section: string, items: LookupItem[], lookupId: string) {
    try {
        const success = await updateLookup(lookupId, section, items);
        if (success) {
            lookupDrawerStore.update(store => ({ ...store, open: false }));
            const response = await getAllLookups();
            if (response.success && response.data) {
                window.dispatchEvent(new CustomEvent('lookupsUpdated', { detail: response.data }));
            }
            return true;
        }
        return false;
    } catch (error) {
        logError(error, "lookup-drawer-store", undefined, { operation: "saveLookup", section, itemsCount: items.length.toString() });
        return false;
    }
} 